<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="isOpen"
      persistent
      max-width="1000px"
    >
      <v-card class="create-bridge-signing">
        <v-card-title class="toolbar primary white--text">
          <v-icon dark>
            note_add
          </v-icon>
          <h3
            class="title ml-2"
          >
            Edit Account
          </h3>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="onToggleOpen"
          >
            X
          </v-btn>
        </v-card-title>
        <v-progress-linear
          v-if="isLoading"
          :indeterminate="true"
          class="ma-0"
        />
        <v-card-text>
          <v-container
            grid-list-md
            class="pa-0"
          >
            <v-layout
              wrap
              class="form-group"
            >
              <v-flex xs12>
                <h6 class="subheading">
                  Account
                </h6>
                <p>
                  BE CAREFUL!
                </p>
              </v-flex>
              <v-flex
                xs12
                md12
              >
                <v-textarea
                  v-model="strategy"
                  label="Strategy"
                  rows="20"
                  background-color="amber lighten-4"
                  color="orange orange-darken-4"
                />
              </v-flex>
            </v-layout>
          </v-container>
          <v-alert
            v-for="e in error"
            :key="e.path"
            :value="error"
            type="error"
            color="error"
          >
            {{ e.message }}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            flat
            @click="onToggleOpen"
          >
            Cancel
          </v-btn>
          <v-btn
            :disabled="isLoading"
            :loading="isSaving"
            color="primary"
            @click="submit"
          >
            <span>
              Save Account
            </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>

export default {
  name: 'ShowAccountEdit',

  props: {
    strategyId: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    toggleOpen: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    strategy: '',
    isOpenProp: this.isOpen,
    isLoading: false,
    isSaving: false,
    error: null,
  }),
  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch('fetchStrategyLatest', this.strategyId);
    this.isLoading = false;
    this.strategy = JSON.stringify(this.$store.state.strategiesStore.strategyLatest, null, '  ');
  },
  methods: {
    onToggleOpen() {
      this.toggleOpen();
      this.error = null;
    },
    submit() {
      this.isLoading = true;
      this.isSaving = true;
      this.$store
        .dispatch('storeStrategy', JSON.parse(this.strategy))
        .then(() => {
          this.onToggleOpen();
        })
        .catch((err) => {
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
          this.isSaving = false;
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/roboInvesting/dialogs/account/ShowAccountEdit.vue